<template lang="html">
  <div class="dashboard">
    <v-header :name="name"></v-header>
    <div class="container">
      <v-left-details></v-left-details>
      <v-map :activeItem="activeItem" @indexChange="indexChange"></v-map>
      <v-details :activeItem="activeItem" @indexChange="indexChange"></v-details>
      <!-- <v-sign></v-sign> -->
    </div>
  </div>
</template>

<script>
import header from 'components/common/header'
import details from 'components/base/details'
import leftDetails from 'components/base/leftDetails'
import map from 'components/base/map'
import sign from 'components/base/sign'
export default {
  data() {
    return {
      items: [],
      activeItem: 0,
      name: '广西百色翠丰特色农产品有限责任公司'
    }
  },
  mounted() {
  },
  methods: {
    jumpChild() {
      this.$router.push('/dashboardChild');
    },
    // 下标改变事件
    indexChange(newIndex) {
      this.activeItem = newIndex;
    }
  },
  components: {
    'v-header': header,
    'v-left-details': leftDetails,
    'v-details': details,
    'v-map': map,
    'v-sign': sign
  }
}

</script>

<style lang="stylus" scoped>
.item
    margin-bottom 15px
.dashboard
    position relative
    width 100%
    height 100%
    margin 0
    padding 0
    background url('../../../static/img/common/bg.png')
    background-size 100% 100%
.container
    display flex
    height 100%
    padding 15px
</style>



// WEBPACK FOOTER //
// index.vue?6c2f5d5e